module.exports = __webpack_public_path__ + "static/media/submissionSuccessSatisfied.5afec809.svg";